export class Brand {
  id: number;
  name: string;
  code: string;
  fechaBaja?: string;
}